export const CLEANUP_OPERATOR_PAGE_STATE = 'cleanup-operator-page-state';
const cleanupOperatorPageState = () => ({ type: CLEANUP_OPERATOR_PAGE_STATE });
export default cleanupOperatorPageState;
